<p-toast></p-toast>

<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [closeOnEscape]="true" [draggable]="false"
    [dismissableMask]="false" [focusOnShow]="false" [style]="{ width: '40rem' }" header="Validación de Transferencias"
    (onShow)="onShow()" appendTo="body">
    <div class="flex flex-col gap-4">

        <!-- Rango (preseleccionado: 1 hora hacia atrás) -->
        <div class="flex flex-wrap gap-3">
            <div class="flex flex-col gap-1 flex-1">
                <label class="font-semibold text-sm text-surface-700 dark:text-surface-300" for="gnbDesde">Desde (fecha
                    y hora)</label>
                <p-datepicker id="gnbDesde" [(ngModel)]="desde" [showTime]="true" [showSeconds]="true" hourFormat="24"
                    dateFormat="dd/mm/yy" [style]="{ width: '100%' }" appendTo="body"></p-datepicker>
            </div>
            <div class="flex flex-col gap-1 flex-1">
                <label class="font-semibold text-sm text-surface-700 dark:text-surface-300" for="gnbHasta">Hasta (fecha
                    y hora)</label>
                <p-datepicker id="gnbHasta" [(ngModel)]="hasta" [showTime]="true" [showSeconds]="true" hourFormat="24"
                    dateFormat="dd/mm/yy" [style]="{ width: '100%' }" appendTo="body"></p-datepicker>
            </div>
        </div>

        <!-- Titular Cuenta + monto -->
        <div class="flex flex-wrap gap-3">
            <div class="flex flex-col gap-1 flex-1">
                <label class="font-semibold text-sm text-surface-700 dark:text-surface-300" for="gnbCliente">Titular de
                    la Cuenta</label>
                <input id="gnbCliente" #clienteInput type="text" pInputText [(ngModel)]="clienteEmisor" maxlength="10"
                    placeholder="Máx. 10 letras" (keyup.enter)="validar()" [style]="{ width: '100%' }" />
                <small class="text-surface-400">Coincide por inicio del nombre.</small>
            </div>
            <div class="flex flex-col gap-1 flex-1">
                <label class="font-semibold text-sm text-surface-700 dark:text-surface-300" for="gnbMonto">Monto
                    (Gs)</label>
                <input id="gnbMonto" type="text" pInputText [(ngModel)]="montoTexto" placeholder="Ej: 1.100.000"
                    (input)="formatMonto()" (keyup.enter)="validar()" [style]="{ width: '100%' }" />
            </div>
        </div>

        <!-- Detalle de cada transacción -->
        @if (!loading && report) {
        <div class="flex flex-col gap-[17px]">
            <div class="text-[17px] text-surface-600 dark:text-surface-400">
                {{ transacciones.length }} transacción(es) encontrada(s)
                @if (clienteEmisor.trim()) {
                <span>para el cliente <span class="font-semibold">{{ clienteEmisor }}</span></span>
                }
                <span>por Gs {{ montoTexto || monto }}</span>
            </div>

            @if (transacciones.length === 0) {
            <div class="p-[17px] rounded-lg bg-surface-100 dark:bg-surface-800 text-[17px] text-surface-500 italic">No
                se encontraron transacciones con los datos indicados.</div>
            } @else {
            <div class="flex flex-col gap-[9px] max-h-96 overflow-auto pr-1">
                @for (mov of transacciones; track $index) {
                @if (mov.detail || mov.embeddedDetail) {
                <div class="p-[17px] rounded-lg text-[17px]"
                    [class]="mov.detail ? statusClass(mov.detail.validationStatus) : 'bg-surface-100 dark:bg-surface-800 border border-surface-200 dark:border-surface-700'">
                    <div class="flex flex-wrap items-center gap-[9px] mb-[9px]">
                        @if (mov.comprobante) {
                        <span
                            class="inline-flex items-center gap-1 font-mono text-[15px] font-semibold text-green-700 dark:text-green-400">
                            <i class="pi pi-check-circle"></i>{{ mov.comprobante }} </span>
                        }
                        @if (mov.detail) {
                        <p-tag [value]="statusLabel(mov.detail.validationStatus)"
                            [severity]="statusSeverity(mov.detail.validationStatus)" />
                        }
                        @if (mov.status) {
                        <p-tag [value]="mov.status" [severity]="statusSeveritySts(mov.status)" />
                        }
                    </div>

                    <div class="mb-[9px]">
                        <div class="font-semibold">Numero de Transacción</div>
                        <div class="flex items-center gap-[9px]">
                            <span class="font-mono text-[19px] font-bold">{{ mov.eqSeq || mov.ntryRef || '-' }}</span>
                            @if (mov.eqSeq || mov.ntryRef) {
                            <button pButton type="button" icon="pi pi-copy" text rounded severity="secondary"
                                pTooltip="Copiar Nro de Transaccion"
                                (click)="copiarEqSeq(mov.eqSeq || mov.ntryRef)"></button>
                            }
                        </div>
                    </div>

                    <div class="space-y-[4px]">
                        @if (mov.detail) {
                        <div>
                            Monto: <span class="font-semibold">{{ mov.detail.currency }} {{ mov.detail.amount != null ?
                                (mov.detail.amount | number: '1.0-2') : '-' }}</span>
                        </div>
                        @if (mov.detail.debtorName) {
                        <div>Titular: {{ mov.detail.debtorName }}</div>
                        }
                        @if (mov.detail.creditorName) {
                        <div>Acreedor: {{ mov.detail.creditorName }}</div>
                        }
                        @if (mov.detail.acctSvcrRef) {
                        <div>
                            Ref. banco: <span class="font-mono text-[15px]">{{ mov.detail.acctSvcrRef }}</span>
                        </div>
                        }
                        @if (mov.detail.errorMessage) {
                        <div class="text-[15px] mt-1 text-surface-500">{{ mov.detail.errorMessage }}</div>
                        }
                        }
                        @if (mov.debtorBankName || mov.debtorBankBic) {
                        <div>Banco origen (ordenante): {{ mov.debtorBankName || mov.debtorBankBic }}</div>
                        }
                        @if (mov.bookingDate) {
                        <div>
                            Fecha y hora: <span class="font-mono text-[15px]">{{ mov.bookingDate }}</span>
                        </div>
                        }
                        @if (mov.creditorBankName || mov.creditorBankBic) {
                        <div>Banco destino (beneficiario): {{ mov.creditorBankName || mov.creditorBankBic }}</div>
                        }
                    </div>
                </div>
                }
                }
            </div>
            }
        </div>
        }
    </div>

    <ng-template #footer>
        <div class="flex justify-end w-full">
            @if (!buscado) {
                <p-button label="Buscar Transferencia" icon="pi pi-search" severity="info" [loading]="loading" (click)="validar()"></p-button>
            } @else {
                <p-button label="Nueva Búsqueda" icon="pi pi-refresh" severity="secondary" (click)="nuevaBusqueda()"></p-button>
            }
        </div>
    </ng-template>
</p-dialog>